export default "__VITE_ASSET__CXNZ9a$o__"